let vimeoOptions = {
    playsinline: true,
    background: true,
}

let videoWrapper, player, videoId, videoType, checkViewPort, controls, autoplay
function initPlayers() {
    videoWrapper = document.querySelectorAll('.video-player-wrapper')

    if (videoWrapper.length === 0) return

    videoWrapper.forEach(function (wrapper) {
        let options, video
        player = wrapper.querySelector('.video-player')
        videoId = wrapper.getAttribute('data-video-id')
        videoType = wrapper.getAttribute('data-video-type')
        checkViewPort = wrapper.getAttribute('data-video-check-viewport')
        controls = wrapper.getAttribute('data-video-controls')
        autoplay = wrapper.getAttribute('data-video-autoplay')

        if (videoType === 'html5') {
            video = player.querySelector('video')
        }

        if (videoType === 'vimeo') {
            options = vimeoOptions
            options.id = videoId
            if (controls === '1') {
                options.background = false
                options.controls = true
            }

            if (autoplay !== '1') {
                options.background = false
                options.playsinline = false
                options.autoplay = false
                options.controls = false
            }
            video = new Vimeo.Player(player, options)
        }

        // check if player is in viewport on load
        if (checkViewPort === '1') {
            if (isInViewport(wrapper)) {
                if (videoType === 'vimeo' || videoType === 'html5') {
                    video.play()
                }
            } else {
                if (videoType === 'vimeo' || videoType === 'html5') {
                    video.pause()
                }
            }
        }
    })
}

document.addEventListener('DOMContentLoaded', initPlayers)
window.addEventListener('scroll', initPlayers)

// check if player is in viewport
function isInViewport(elem) {
    var bounding = elem.getBoundingClientRect()
    return (
        bounding.top >= -100 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight + 100 || document.documentElement.clientHeight + 100) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
}
